const TRAVELER_QUERY_KEY = "traveler"
const TRAVELER_CODE_PATTERN = /^[A-Za-z0-9_-]{1,50}$/

function normalizeTravelerCode(value) {
  if (Array.isArray(value)) return null
  if (typeof value !== "string") return null
  const code = value.trim()
  return TRAVELER_CODE_PATTERN.test(code) ? code : null
}

function getTravelerCodeFromRoute(route) {
  return normalizeTravelerCode(route && route.query ? route.query[TRAVELER_QUERY_KEY] : null)
}

function createTravelerCarryLocation(to, from) {
  if (!to || !from || to.name === "traveler-entry" || from.name === "traveler-entry" || String(to.path || "").startsWith("/admin")) return null
  if (Object.prototype.hasOwnProperty.call(to.query || {}, TRAVELER_QUERY_KEY)) return null

  const travelerCode = getTravelerCodeFromRoute(from)
  if (!travelerCode) return null
  return {
    path: to.path,
    query: { ...(to.query || {}), [TRAVELER_QUERY_KEY]: travelerCode },
    hash: to.hash || "",
  }
}

function safeLocalPath(value) {
  if (typeof value !== "string" || !value.startsWith("/") || value.startsWith("//") || value.includes("\\")) return null
  try {
    const base = "https://lafia.invalid"
    const parsed = new URL(value, base)
    if (parsed.origin !== base) return null
    return parsed.pathname + parsed.search + parsed.hash
  } catch (error) {
    return null
  }
}

function createTravelerLoginDestination(state) {
  const loginState = state && typeof state === "object" ? state : {}
  const travelerCode = normalizeTravelerCode(loginState[TRAVELER_QUERY_KEY])
  const callbackUrl = safeLocalPath(loginState.callbackUrl)
  if (!callbackUrl) return travelerCode ? `/?${TRAVELER_QUERY_KEY}=${encodeURIComponent(travelerCode)}` : "/"

  const parsed = new URL(callbackUrl, "https://lafia.invalid")
  if (travelerCode && !parsed.searchParams.has(TRAVELER_QUERY_KEY)) parsed.searchParams.set(TRAVELER_QUERY_KEY, travelerCode)
  return parsed.pathname + parsed.search + parsed.hash
}

function carryTravelerHref(href, base, code) {
  if (!normalizeTravelerCode(code)) return href
  try {
    const url = new URL(href, base)
    if (url.origin !== new URL(base).origin || url.pathname.startsWith('/admin') || url.pathname.startsWith('/traveler/')) return href
    if (!url.searchParams.has(TRAVELER_QUERY_KEY)) url.searchParams.set(TRAVELER_QUERY_KEY, code)
    return url.href
  } catch (_) { return href }
}

function bindTravelerLinks(rootDocument, getCode) {
  const documents = new Set()
  const click = event => {
    const link = event.target && event.target.closest && event.target.closest('a[href]')
    if (link) {
      link.href = carryTravelerHref(link.getAttribute('href'), link.ownerDocument.baseURI, getCode())
      const view = rootDocument.defaultView
      if (view && view.location.pathname === '/traveler_test/index.html') {
        const target = new URL(link.href)
        if (target.origin === view.location.origin && !/\.[a-z0-9]+$/i.test(target.pathname)) {
          event.preventDefault()
          view.location.hash = target.pathname + target.search + target.hash
        }
      }
    }
  }
  const load = event => {
    if (event.target && event.target.tagName === 'IFRAME') {
      try { bind(event.target.contentDocument) } catch (_) { /* 외부 프레임은 접근하지 않는다. */ }
    }
  }
  function bind(doc) {
    if (!doc || documents.has(doc)) return
    documents.add(doc)
    doc.addEventListener('click', click, true)
    doc.addEventListener('load', load, true)
    doc.querySelectorAll('iframe').forEach(frame => {
      try { bind(frame.contentDocument) } catch (_) { /* 외부 프레임 제외 */ }
    })
  }
  bind(rootDocument)
  return () => documents.forEach(doc => {
    doc.removeEventListener('click', click, true)
    doc.removeEventListener('load', load, true)
  })
}

// 카카오·구글 로그인에 실어 보낸 state(로그인 화면이 받은 돌아갈 주소·트래블러 코드 등)를 읽는다
function decodeLoginState(value) {
  try {
    return value ? JSON.parse(decodeURIComponent(atob(value))) : null
  } catch (error) {
    return null
  }
}

// 카카오·구글 로그인이 실패하거나 취소됐을 때 돌아갈 로그인 화면: 돌아갈 예약 주소를 그대로 들고 간다
function loginPageWithState(value) {
  return { path: "/auth/login", query: decodeLoginState(value) || {} }
}

module.exports = {
  decodeLoginState,
  loginPageWithState,
  carryTravelerHref,
  bindTravelerLinks,
  TRAVELER_QUERY_KEY,
  normalizeTravelerCode,
  getTravelerCodeFromRoute,
  createTravelerCarryLocation,
  createTravelerLoginDestination,
}
